<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">实名认证</h3>
        <div class="wrap">
          <el-form ref="dataInfo" :rules="rules" :model="dataInfo" label-width="180px">
            <el-form-item label="上传身份证人像面：" ref="empIdcardFront" prop="empIdcardFront">
              <el-upload
                class="avatar-uploader"
                accept=".jpg,.jpeg, .jif,.png"
                :action="uploadUrl"
                :data="{fileType: 'sfzzm'}"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-success="frontSuccess"
                :on-progress="handleProgress"
              >
                <img v-if="dataInfo.empIdcardFront!=''" :src="dataInfo.empIdcardFront" class="avatar" />
                <img v-if="dataInfo.empIdcardFront==''" src="../../static/zm.jpg" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  请上传本人的身份证人像面，图片的格式为jpg, gif, png, 建议图片大小不超过2MB
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="上传身份证国徽面：" ref="empIdcardNegative" prop="empIdcardNegative">
              <el-upload
                class="avatar-uploader"
                accept=".jpg,.jpeg, .jif,.png"
                :action="uploadUrl"
                :data="{fileType: 'sfzfm'}"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-success="reverseSuccess"
                :on-progress="handleProgress"
              >
                <img
                  v-if="dataInfo.empIdcardNegative!=''"
                  :src="dataInfo.empIdcardNegative"
                  class="avatar"
                />
                <img
                        v-if="dataInfo.empIdcardNegative==''"
                        src="../../static/fm.jpg"
                        class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  请上传本人的身份证国徽背面，图片的格式为jpg, gif, png, 建议图片大小不超过2MB
                </div>
              </el-upload>
            </el-form-item>
            <!-- <el-form-item label="拍照：" prop="empIdcardFront">
              <img v-if="imageUrl!=''" :src="imageUrl" alt />
              <div>
                <el-button type="primary" plain size="small" @click="photo">点击拍照</el-button>
              </div>
            </el-form-item>-->
            <div style="width: 100%;text-align: center">
              <el-button type="primary" size="small" @click="uploadAccountPhoto('dataInfo')">保存</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="实名认证拍照" :visible.sync="photoImgDialog" width="30%" center @close="closeForm">
      <div style="width:250px;margin:0 auto;text-align: center;">
        <CameraDialog
          ref="camera"
          :videoWidth="videoWidth"
          :videoHeight="videoHeight"
          @child-url="getUlr"
        />
        <el-button type="primary" @click="getPhoto" style="margin-top:20px">点击拍照</el-button>
      </div>
    </el-dialog>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import CameraDialog from "../views/CameraDialog/CameraDialog2";
import { bizURL } from "../api/baseUrl";
import http from "../api/module";
import { getBizListByPost } from "../api/service.js";

if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function(callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === "https:";
var canEnumerate = false;

if (
  typeof MediaStreamTrack !== "undefined" &&
  "getSources" in MediaStreamTrack
) {
  canEnumerate = true;
} else if (
  navigator.mediaDevices &&
  !!navigator.mediaDevices.enumerateDevices
) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;
export default {
  name: "approve",
  data() {
    // 图片验证
    var valiIcon = (rule, value, callback) => {
      if (!this.dataInfo.empIdcardFront) {
        // hasFmt设置为true/false
        callback(new Error("请上传身份证人像面"));
      } else {
        callback();
      }
    };
    return {
      uploadUrl: bizURL + "/file/uploadFile",
      photoUrl: bizURL + "/file/uploadBASE64",
      frontUrl: "",
      reverseUrl: "",
      imageUrl: "",
      videoWidth: 100,
      videoHeight: 100,
      photoData: {
        BASE64: "BASE64",
        fileType: "个人拍照",
        fileName: "个人拍照.png"
      },
      dataInfo: {
        empIdcardFront:"",
        empIdcardNegative:""
      },
      photoImgDialog: false,
      empPersonnelStatus: 0,
      rules: {
        empIdcardFront: [
          // { required: true, validator: valiIcon, trigger: "click" }
          { required: true, message: "请上传身份证人像面", trigger: "click" }
        ],
        empIdcardNegative: [
          { required: true, message: "请上传身份证国徽面", trigger: "click" }
        ],
        imageUrl: [{ required: true, message: "上传正面照", trigger: "blur" }]
      }
    };
  },
  components: {
    HeadCom,
    CameraDialog, // CameraDialog
    FooterCom
  },
  mounted() {
    this.userInfo();
  },
  methods: {
    userInfo() {
      http
        .getUserInfo()
        .then(data => {
          console.log(data);
          if (data.data.code == "200" || data.data.success == true) {
            this.dataInfo = data.data.data;
            this.imageUrl = data.data.data.empContractScanner;
            this.empPersonnelStatus = data.data.data.empPersonnelStatus;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$messageerror({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    beforeAvatarUpload(file) {
      /* const isJPG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png"; */
      // const isBMP = file.type === "image/bmp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      /* if (!isJPG && !isGIF && !isPNG) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片必须是JPG/GIF/PNG 格式！"
        });
      } */
      if (!isLt2M) {
        this.$message.warning({
          duration: 1000,
          message:"上传图片大小不能超过 2MB！"
        });
      }
      return isLt2M;
    },
    handleProgress(event, file, fileList) {
      // console.log(file, "handleProgress");
    },
    // 获取上传图片路径
    frontSuccess(res, file, fileList) {
      this.dataInfo.empIdcardFront = res.data;
      this.$refs.empIdcardFront.clearValidate();
      // this.getPhote(1);
    },
    reverseSuccess(res, file, fileList) {
      this.dataInfo.empIdcardNegative = res.data;
      this.$refs.empIdcardNegative.clearValidate();
      // this.getPhote(2);
    },
    photoSuccess(res, file, fileList) {
      this.dataInfo.empHeadportrait = res.data;
      // this.getPhote(3);
    },
    getPhote(fileType) {
      http
        .savePhoto({
          photoUrl: this.uploadUrl,
          fileType: fileType
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: data.data.message
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    onSubmit() {
      if (!this.frontUrl) {
        this.$message.warning({
          duration: 1000,
          message: "请上传身份证正面!"
        });
      } else if (!this.reverseUrl) {
        this.$message.warning({
          duration: 1000,
          message: "请上传身份证反面!"
        });
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请上传拍照!"
        });
      }
    },
    photo() {
      var that = this;
      this.checkDeviceSupport(function() {
        if (hasWebcam == false) {
          console.log("没有摄像头！");
          // that.$message.warning("系统未检测到摄像头，请安装摄像头后再进行实名认证");
          that.$message.warning(
            "实名认证拍摄照片，需要启动摄像头，请启动摄像头"
          );
          return false;
        } else {
          that.photoImgDialog = true;
          that.$refs.camera.getCompetence();
          // if (isWebcamAlreadyCaptured == false) {
          //   console.log("捕获摄像头失败，请重新安装摄像头！");
          //   that.$message.warning("捕获摄像头失败，请重新安装摄像头");
          //   return false;
          // } else {

          // }
        }
      });
    },
    getPhoto() {
      this.$refs.camera.setImage();
      this.photoImgDialog = false;
    },
    getUlr(imgUrl) {
      this.imageUrl = imgUrl;
    },
    closeForm() {
      this.$refs.camera.stopNavigator();
    },
    uploadAccountPhoto(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .savePhoto({
              empIdcardFront: this.dataInfo.empIdcardFront,
              empIdcardNegative: this.dataInfo.empIdcardNegative,
              // empContractScanner: this.imageUrl
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: data.data.message
                });
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {});
        }
        // if (valid) {
        //   var url = "/myAccount/uploadAccountPhoto";
        //   if (
        //     this.dataInfo.empIdcardFront == "" ||
        //     this.dataInfo.empIdcardNegative == "" ||
        //     this.imageUrl == ""
        //   ) {
        //     that.$message.warning("请上传所有必传图片");
        //     return false;
        //   }
        //   var data = {
        //     empIdcardFront: this.dataInfo.empIdcardFront,
        //     empIdcardNegative: this.dataInfo.empIdcardNegative,
        //     empContractScanner: this.imageUrl
        //   };
        //   // var headers =  {headers: { 'Content-Type': 'multipart/form-data'}};
        //   // console.log(headers,123);
        //   getBizListByPost(url, data).then(res => {
        //     if (res.success) {
        //       that.$message.success("保存成功");
        //     }
        //   });
        // } else {
        //   console.log("error submit!!");
        //   return false;
        // }
      });
    },
    checkDeviceSupport(callback) {
      //检测是否安装摄像头
      if (!canEnumerate) {
        return;
      }
      if (
        !navigator.enumerateDevices &&
        window.MediaStreamTrack &&
        window.MediaStreamTrack.getSources
      ) {
        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(
          window.MediaStreamTrack
        );
      }

      if (!navigator.enumerateDevices && navigator.enumerateDevices) {
        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
      }

      if (!navigator.enumerateDevices) {
        if (callback) {
          callback();
        }
        return;
      }

      MediaDevices = [];
      navigator.enumerateDevices(function(devices) {
        devices.forEach(function(_device) {
          var device = {};
          for (var d in _device) {
            device[d] = _device[d];
          }

          if (device.kind === "audio") {
            device.kind = "audioinput";
          }

          if (device.kind === "video") {
            device.kind = "videoinput";
          }

          var skip;
          MediaDevices.forEach(function(d) {
            if (d.id === device.id && d.kind === device.kind) {
              skip = true;
            }
          });

          if (skip) {
            return;
          }

          if (!device.deviceId) {
            device.deviceId = device.id;
          }

          if (!device.id) {
            device.id = device.deviceId;
          }

          if (!device.label) {
            device.label = "Please invoke getUserMedia once.";
            if (!isHTTPs) {
              device.label =
                "HTTPs is required to get label of this " +
                device.kind +
                " device.";
            }
          } else {
            if (device.kind === "videoinput" && !isWebcamAlreadyCaptured) {
              isWebcamAlreadyCaptured = true;
            }

            if (device.kind === "audioinput" && !isMicrophoneAlreadyCaptured) {
              isMicrophoneAlreadyCaptured = true;
            }
          }

          if (device.kind === "audioinput") {
            hasMicrophone = true;
          }

          if (device.kind === "audiooutput") {
            hasSpeakers = true;
          }

          if (device.kind === "videoinput") {
            hasWebcam = true;
          }

          // there is no 'videoouput' in the spec.

          MediaDevices.push(device);
        });

        if (callback) {
          callback();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  font-size: 16px;
}
.avatar-uploader {
  width: 100%;
  height: 108px !important;
}
.avatar-uploader-icon {
  width: 170px;
  height: 108px;
  line-height: 108px;
  font-size: 24px;
}

// .avatar {
//   width: 170px;
//   height: 108px;
// }

/deep/.el-upload.el-upload--text{
  width: 170px;
  height: 108px;
}

.avatar {
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.el-icon-plus.avatar-uploader-icon {
  line-height: 108px;
}
.el-upload__tip {
  left: 190px;
}

.cont {
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  background: #ffffff;
  .wrap {
    padding: 20px 100px;
  }
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
  .btns {
    text-align: center;
    /deep/.el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
.tips {
  color: red;
}
</style>
